import { combineReducers } from "redux";
import conditionalRebates from "src/store/reducers/conditionalRebates";
import messages from "src/store/reducers/messages";
import testDrive from "src/store/reducers/testDrive";
import tracking from "src/store/reducers/tracking";
import tradeIn from "src/store/reducers/tradeIn";
import { CLEAR_ALL, CLEAR_ALL_EXCEPT_ACCOUNT } from "../constants";
import accessories from "./accessories";
import account from "./account";
import browser from "./browser";
import creditApp from "./creditApp";
import creditIQ from "./creditIQ";
import currentDeal from "./currentDeal";
import deal from "./deal";
import dealerChanges from "./dealerChanges";
import dealerOffer from "./dealerOffer";
import hasSignatures from "./hasSignatures";
import onlineShopper, { initialState as onlineShopperInitialState } from "./onlineShopper";
import userInfo from "./userInfo";
import vehicles from "./vehicles";

const app = combineReducers({
    accessories,
    account,
    browser,
    creditApp,
    creditIQ,
    currentDeal,
    deal,
    dealerOffer,
    messages,
    onlineShopper,
    tradeIn,
    userInfo,
    vehicles,
    conditionalRebates,
    hasSignatures,
    dealerChanges,
    tracking,
    testDrive,
});

export default (state: any, action: any) => {
    if (action.type === CLEAR_ALL) {
        state = undefined;
    }
    if (action.type === CLEAR_ALL_EXCEPT_ACCOUNT) {
        state = {
            account: state.account,
            browser: state.browser,
            onlineShopper: {
                ...onlineShopperInitialState,
                env: state.onlineShopper.env,
            },
        };
    }
    return app(state, action);
};
